import { useState, useEffect } from 'react';
import SheetModal from '@/components/General/SheetModal';
import SheetSelector from '@/components/General/inputs/SheetSelector';

const ChangeConnectedProfileModal = ({ isOpen, onClose, onConfirm, userName, currentPerson, excludePersonIds = [], loading = false }) => {
    const [selectedPerson, setSelectedPerson] = useState(null);

    useEffect(() => {
        if (isOpen) {
            setSelectedPerson(null);
        }
    }, [isOpen]);

    const handleConfirm = () => {
        if (!selectedPerson) return;
        onConfirm?.(selectedPerson);
    };

    return (
        <SheetModal
            isOpen={isOpen}
            onClose={onClose}
            onCancel={onClose}
            title="Change Connected Profile"
            subtitle={`Select the profile ${userName || 'this user'} should be connected to`}
            confirmText="Change Profile"
            onConfirm={handleConfirm}
            loading={loading}
        >
            <SheetSelector
                type="people"
                title="New Connected Profile"
                placeholder="Search for a person..."
                value={selectedPerson}
                onChange={setSelectedPerson}
                excludeIds={[...(currentPerson?.id ? [currentPerson.id] : []), ...excludePersonIds]}
            />
        </SheetModal>
    );
};

export default ChangeConnectedProfileModal;
